<div class="vc-multi-select-with-groups-wrapper">
    <mat-form-field
        class="vc-mat-form-field"
        [class.vc-readonly-field]="readonly"
        [class.vc-filter-minimal-styles]="minimalStyles"
        [class.vc-no-label]="!label || label === ''">
        <mat-label>{{ label }}</mat-label>
        <mat-select
            #selectInput
            disableOptionCentering
            multiple
            [compareWith]="compareWith"
            [errorStateMatcher]="errorStateMatcher"
            [required]="required"
            [disabled]="disabled || readonly"
            (blur)="touched = true; validate()"
            [(ngModel)]="groupedValues"
            [matTooltip]="groupedValues | textRenderer: getTooltipText"
            [matTooltipDisabled]="false"
            [matTooltipPosition]="tooltipPosition"
            (focus)="checkIfShowTooltip(selectInput)"
            (mouseover)="checkIfShowTooltip(selectInput)"
            (openedChange)="openedChange($event)">
            @if (showFilter) {
                <vc-input
                    #inputElement
                    class="vc-multi-select-with-groups-input"
                    [label]="filterLabel"
                    tabindex="0"
                    [placeholder]="filterPlaceholder"
                    [minimalStyles]="true"
                    [showClear]="showClearForFilter"
                    [(value)]="filter"></vc-input>
            }
            @for (group of options; track group) {
                <mat-optgroup
                    class="vc-multi-select-with-groups-sticky-header"
                    [class.show-filter]="showFilter"
                    [style.display]="checkIfShowGroup(group) ? 'inline' : 'none'">
                    <vc-tooltip-text
                        [text]="group.key | textRenderer: groupRenderer"
                        style="overflow: auto"></vc-tooltip-text>
                    @for (option of group.value; track $index) {
                        <mat-option
                            [value]="{ key: group.key, value: option }"
                            [style.display]="checkIfShowOption(option) ? 'flex' : 'none'">
                            <vc-tooltip-text
                                [text]="option | textRenderer: optionRenderer"
                                style="overflow: auto"></vc-tooltip-text>
                        </mat-option>
                    }
                </mat-optgroup>
            }
        </mat-select>

        <div matSuffix class="vc-field-suffix">
            @if (suffixIcon && (!values || values.length === 0)) {
                <mat-icon class="material-icons-outlined">{{ suffixIcon }}</mat-icon>
            }
            @if (values && values.length > 0 && showClear && !disabled && !readonly) {
                <vc-button
                    iconColor="var(--icon-neutral)"
                    ariaLabel="Clear input"
                    iconName="close"
                    mode="icon-plain"
                    (trigger)="$event.stopPropagation(); clear()"></vc-button>
            }
        </div>
        @if (!valid && touched) {
            <mat-hint class="mat-error vc-error-message">{{ errorMessage }}</mat-hint>
        }
    </mat-form-field>
</div>
